var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_Set.js
// module id = 1631
// module chunks = 3 9 13